var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import Modal, { setAppElement } from 'react-modal';
import styled from 'styled-components';
import { FiltersSelect } from './filters-select';
import { MinusIcon, PlusIcon, XIcon } from './icons';
import noScroll from 'no-scroll';
var Button = styled.button({
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'var(--font-family-primary)',
    lineHeight: 'normal',
    alignContent: 'baseline',
    padding: '15px 18px',
    backgroundColor: '#fff',
    border: '2px solid #dbdbdb',
    ':active': {
        backgroundColor: '#dadada',
    },
});
var Container = styled.div({
    minHeight: '100%',
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
});
var Header = styled.header({
    padding: '20px 20px 10px 20px',
    borderBottom: '2px solid #d6d6d6',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
});
var Footer = styled.footer({
    flexShrink: 0,
    backgroundColor: 'white',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
var Heading = styled.h1({
    margin: 0,
});
var CloseButton = styled.button({
    cursor: 'pointer',
    fontWeight: 'bold',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    fontFamily: 'var(--font-family-primary)',
    lineHeight: 'normal',
    alignContent: 'baseline',
    backgroundColor: '#fff',
    border: 'none',
});
var Content = styled.div({
    margin: '0 20px',
    flexGrow: 1,
    minHeight: '100%',
    height: '100px',
    overflowY: 'auto',
});
export var FiltersModal = function (_a) {
    var filters = _a.filters, value = _a.value, onChange = _a.onChange, className = _a.className, appElementSelector = _a.appElementSelector;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState([]), openFilterIds = _c[0], setOpenFilterIds = _c[1];
    var _d = useState(value), tempSelectedOptions = _d[0], setTempSelectedOptions = _d[1];
    var showFilter = useCallback(function (id) {
        setOpenFilterIds(function (current) { return current.concat(id); });
    }, []);
    var hideFilter = useCallback(function (id) {
        setOpenFilterIds(function (current) { return current.filter(function (filterId) { return filterId !== id; }); });
    }, []);
    var onHide = useCallback(function () {
        setIsOpen(false);
    }, []);
    var onShow = useCallback(function () {
        setIsOpen(true);
    }, []);
    var submit = useCallback(function () {
        onChange(tempSelectedOptions);
        onHide();
    }, [onChange, onHide, tempSelectedOptions]);
    useEffect(function () {
        if (typeof window !== 'undefined')
            setAppElement(appElementSelector);
    }, [appElementSelector]);
    useEffect(function () {
        // To prevent main app from scrolling while we have modal open, we use this
        // noscroll solution. See: https://github.com/reactjs/react-modal/issues/191
        if (isOpen) {
            noScroll.on();
            return function () { return noScroll.off(); };
        }
    });
    // update `tempSelectedOptions` when `value` is updated outside the modal
    useEffect(function () {
        setTempSelectedOptions(value);
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx(Modal, __assign({ isOpen: isOpen, style: { content: { inset: '0px', padding: 0 } } }, { children: _jsxs(Container, { children: [_jsxs(Header, { children: [_jsx(Heading, { children: "Filters" }, void 0), _jsx(CloseButton, __assign({ onClick: onHide }, { children: _jsx(XIcon, { color: "#000", height: 15, width: 15 }, void 0) }), void 0)] }, void 0), _jsx(Content, { children: filters.map(function (filter) {
                                var isOpen = openFilterIds.includes(filter.id);
                                return (_jsx(FiltersSelect, { filter: filter, isOpen: isOpen, onShow: showFilter, onHide: hideFilter, Icon: isOpen ? _jsx(MinusIcon, {}, void 0) : _jsx(PlusIcon, {}, void 0), onChange: setTempSelectedOptions, 
                                    // TODO check if it is necessary to filter
                                    value: tempSelectedOptions.filter(function (o) {
                                        return filter.options.some(function (option) { return o.id === option.id; });
                                    }), className: className }, filter.id));
                            }) }, void 0), _jsx(Footer, { children: _jsx(Button, __assign({ onClick: submit }, { children: "View Results" }), void 0) }, void 0)] }, void 0) }), void 0), _jsx(Button, __assign({ onClick: onShow }, { children: "Filter" }), void 0)] }, void 0));
};
